import React from "react"
import {Input} from "antd"
import type { InputProps } from 'antd';

interface PropsTypes extends InputProps {
    isInvalid?: any
    showErrorMessage?: boolean
    containerStyle?: any
    isPassword?: boolean
}

export const FormInput: React.FC<PropsTypes> = ({isInvalid, showErrorMessage = true, containerStyle, isPassword, ...props}) => {
    return (
        <div className="form-input" style={containerStyle}>
            <div style={{position: 'relative'}}>
                {
                    isPassword
                        ? <Input.Password status={isInvalid ? 'error' : ''}
                                          {...props}
                        />
                        : <Input status={isInvalid ? 'error' : ''}
                                 {...props}
                        />
                }
                {
                    props.value !== undefined && props.value !== null && props.value !== ''
                        ? <span style={{position: 'absolute', top: 1, left: 12, fontSize: 11, zIndex: 100, fontWeight: 600, color: '#8c8c8c', opacity: 0.5}}>
                    {props.placeholder}</span>
                        : null
                }
            </div>
            {isInvalid && showErrorMessage ? <div className="input-error-visible">{isInvalid}</div> : null}
        </div>
    )
}